export const ACTIVITY_TYPE_OPTIONS = [
  { label: 'Phone', value: 'phone' },
  { label: 'Email', value: 'email' },
  { label: 'Text', value: 'sms' },
  { label: 'Social Media', value: 'social_media' },
]
